import TransferNewsFilters from "./TransferNewsFilters";
import TransferNewsClearFilters from "./TransferNewsClearFilters";
import TransfersTable from "./TransfersTable";
import useTransferSection from "../../hooks/transfer-news/useTransferSection";

const TransferNewsSection = ({
  title,
  sortType,
  positions,
  countries,
  handlePlayerClickNavigate,
  handleClubClickNavigate,
}) => {
  const {
    transfers,
    isLoadingTransfers,
    transfersError,
    currentPage,
    hasMore,
    filters,
    competitionSearch,
    setCompetitionSearch,
    showCompetitionDropdown,
    setShowCompetitionDropdown,
    countrySearch,
    setCountrySearch,
    showCountryDropdown,
    setShowCountryDropdown,
    divisionCountrySearch,
    setDivisionCountrySearch,
    showDivisionCountryDropdown,
    setShowDivisionCountryDropdown,
    filteredCompetitions,
    filteredCountries,
    filteredDivisionCountries,
    hasActiveFilters,
    handleCountrySelect,
    handleDivisionCountrySelect,
    handleCompetitionSelect,
    handleLevelChange,
    handlePositionChange,
    handleTypeChange,
    handleDateFromChange,
    handleDateToChange,
    handleClearAllFilters,
    handleClearFilter,
    getSelectedCountryName,
    getSelectedDivisionCountryName,
    getSelectedCompetitionName,
    handlePrevPage,
    handleNextPage,
    fetchTransfers,
  } = useTransferSection(sortType, countries);

  return (
    <div className="mb-12">
      {/* Section Header */}
      <div className="py-4 px-4 md:px-12 border-b border-[#E5E6E8]">
        <h2 className="text-base md:text-xl font-semibold">{title}</h2>
      </div>

      {/* Filters */}
      <TransferNewsFilters
        filters={filters}
        handleLevelChange={handleLevelChange}
        handlePositionChange={handlePositionChange}
        handleTypeChange={handleTypeChange}
        handleDateFromChange={handleDateFromChange}
        handleDateToChange={handleDateToChange}
        countrySearch={countrySearch}
        setCountrySearch={setCountrySearch}
        showCountryDropdown={showCountryDropdown}
        setShowCountryDropdown={setShowCountryDropdown}
        divisionCountrySearch={divisionCountrySearch}
        setDivisionCountrySearch={setDivisionCountrySearch}
        showDivisionCountryDropdown={showDivisionCountryDropdown}
        setShowDivisionCountryDropdown={setShowDivisionCountryDropdown}
        competitionSearch={competitionSearch}
        setCompetitionSearch={setCompetitionSearch}
        showCompetitionDropdown={showCompetitionDropdown}
        setShowCompetitionDropdown={setShowCompetitionDropdown}
        filteredCountries={filteredCountries}
        filteredDivisionCountries={filteredDivisionCountries}
        filteredCompetitions={filteredCompetitions}
        positions={positions}
        handleCountrySelect={handleCountrySelect}
        handleDivisionCountrySelect={handleDivisionCountrySelect}
        handleCompetitionSelect={handleCompetitionSelect}
        getSelectedCountryName={getSelectedCountryName}
        getSelectedDivisionCountryName={getSelectedDivisionCountryName}
        getSelectedCompetitionName={getSelectedCompetitionName}
      />

      {/* Clear Filters */}
      <TransferNewsClearFilters
        hasActiveFilters={hasActiveFilters}
        filters={filters}
        positions={positions}
        getSelectedCountryName={getSelectedCountryName}
        getSelectedDivisionCountryName={getSelectedDivisionCountryName}
        getSelectedCompetitionName={getSelectedCompetitionName}
        handleClearFilter={handleClearFilter}
        handleClearAllFilters={handleClearAllFilters}
        isLoadingTransfers={isLoadingTransfers}
      />

      {/* Transfers Table */}
      <TransfersTable
        isLoadingTransfers={isLoadingTransfers}
        transfersError={transfersError}
        transfers={transfers}
        handlePlayerClickNavigate={handlePlayerClickNavigate}
        handleClubClickNavigate={handleClubClickNavigate}
        fetchTransfers={fetchTransfers}
        currentTransferPage={currentPage}
        transfersHasMore={hasMore}
        handleTransfersPrevPage={handlePrevPage}
        handleTransfersNextPage={handleNextPage}
      />
    </div>
  );
};

export default TransferNewsSection;
